
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.375 14.375a5 5 0 1010 0 5 5 0 00-10 0z","stroke":"#000","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.375 16.875v-5m0 0L12.5 13.75m1.875-1.875l1.875 1.875","stroke":"#5C6970","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.25 16.875H1.875a1.25 1.25 0 01-1.25-1.25V1.875a1.25 1.25 0 011.25-1.25h8.857c.332 0 .65.132.884.366l2.393 2.393c.234.235.366.552.366.884V6.25","stroke":"#000","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3 10.323c.136-.471.414-.872.656-1.294.45-.78.824-1.605 1.225-2.411.396-.797.909-1.653 1.143-2.519.041-.154-.317-.087-.423-.07-.293.049-.57.259-.796.443-.5.407-.53.811-.6 1.42-.102.912.098 1.584.5 2.386.133.267.215.605.485.767.342.205.862.052 1.193-.091 1.3-.561 1.363-2.104 2.011-3.198.15-.252.23-.253.23.057 0 .345-.118 1.032.401 1.032.677 0 1.103-.848 1.645-1.142.259-.141.51-.152.795-.152","stroke":"#000","stroke-linecap":"round"}})])
          )
        }
      }
    